export const fetchBannersTalkShowPageAction = data => {
	return {
		type: 'FETCH_BANNERS_TS_LIST',
		payload: data
	}
}